import type { ReactNode } from "react";
import { Button, type LinkProps } from "../primitives";

export type DrlpCtaLink = Pick<
  LinkProps,
  "href" | "children" | "aria-label" | "analyticsLabel"
> & { analyticsId: string };

// A DRLP CTA is either a plain link or an app-supplied overlay trigger (e.g.
// fin-ai's form-overlay modal). The overlay element owns its own trigger button
// and styling, so the shared component renders it verbatim. Keeping the union
// here means intercom-com's link-only CTAs stay valid unchanged.
export type DrlpCta = DrlpCtaLink | { overlay: ReactNode };

export function renderDrlpCta(
  cta: DrlpCta | undefined,
  variant: "primary" | "secondary" = "primary",
): ReactNode {
  if (!cta) return null;
  if ("overlay" in cta) return cta.overlay;
  return <Button {...cta} variant={variant} data-testid="cta-button" />;
}
